import './version';
export * from '@fluentui/style-utilities';
//# sourceMappingURL=Styling.js.map